var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluemap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.15 0L17.1 1.9125C17.6625 2.025 18 2.5875 18.1125 3.15V16.425C18.1125 16.7625 17.8875 17.2125 17.55 17.4375C17.325 17.55 16.9875 17.6625 16.7625 17.6625C16.7063 17.6625 16.6219 17.6344 16.5375 17.6063C16.4531 17.5781 16.3687 17.55 16.3125 17.55L11.925 15.975L6.3 18H6.075H5.85L0.9 16.0875C0.3375 15.8625 0 15.4125 0 14.85V1.575C0 1.2375 0.225 0.7875 0.5625 0.5625C0.9 0.3375 1.35 0.225 1.8 0.45L6.075 2.025L11.7 0H11.8125H11.925H12.0375H12.15ZM11.3625 1.23749L6.6375 2.92499V16.65L11.3625 14.9625V1.23749ZM1.125 14.85V1.57501C1.125 1.5272 1.125 1.49971 1.13363 1.47527C1.14532 1.44219 1.17281 1.4147 1.2375 1.35001H1.4625L5.625 2.92501V16.65L1.35 15.075C1.125 15.075 1.125 14.9625 1.125 14.85ZM16.8664 16.5247C16.875 16.5003 16.875 16.4728 16.875 16.425V3.15001C16.875 3.03751 16.875 2.92501 16.65 2.92501L12.375 1.35001V15.075L16.5375 16.65H16.7625C16.8272 16.5853 16.8547 16.5578 16.8664 16.5247Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluemap);
export default __webpack_public_path__ + "static/media/bluemap.50cd3075818c370d151665cb3fff7fe7.svg";
export { ForwardRef as ReactComponent };